/**
 * Drafting Center 中文语言包
 */
export default {
    draftingCenter: {
    // 时间格式化
        time: {
            justNow: '刚刚',
            minutesAgo: '{mins}分钟前',
            hoursAgo: '{hours}小时前',
            yesterday: '昨天',
            daysAgo: '{days}天前',
        },

        // 导航
        allDrafts: '所有项目',
        loadMore: '加载更多',
        loadingMore: '加载中...',
        recentDrafts: '最近的项目',
        recentDraftsTooltip: '展示最近 3 天内更新的前 5 条撰写记录',
        allProjects: '所有项目',
        allProjectsRoot: '所有项目（根目录）',

        // 头部搜索和操作
        searchPlaceholder: '搜索项目...',
        newFolder: '新建文件夹',
        newProject: '新建项目',

        // 文件夹树（左侧导航）
        tree: {
            title: '文件夹',
            allProjects: '所有文件夹',
            empty: '暂无文件夹',
            expand: '展开',
            collapse: '折叠',
            newFolderHere: '在此新建文件夹',
            newSubfolder: '新建子文件夹',
        },

        // 首页「选择项目/文件夹」弹框
        projectSelect: {
            trigger: '项目',
            buttonDefault: '默认文件夹',
            tooltip: '选择项目或文件夹',
            title: '选择项目或文件夹',
            allProjects: '所有项目',
            projects: '项目',
            selectFolderHint: '请选择左侧文件夹以查看项目',
            noProjects: '该文件夹下暂无项目',
            confirm: '确认选择',
            willUseDefault: '将创建到默认文件夹',
            willCreateIn: '将在「{name}」中创建新项目',
            willAppendTo: '将追加到项目「{name}」',
        },
        sortButton: '排序',
        total: '总计',

        // 操作
        create: '创建',
        edit: '编辑',
        delete: '删除',
        move: '移动',
        moveTo: '移动到...',
        moveToFolder: '移动到文件夹',
        moveHere: '移动到这里',
        save: '保存',
        cancel: '取消',

        createProjectDialog: {
            projectName: '项目名称',
            projectNamePlaceholder: '选填，不填将自动生成',
            docType: '类型',
            techContent: '技术内容',
            uploadFiles: '上传文件',
            uploadFilesHint: '支持 PDF、Word、图片，最多 5 个',
            addFile: '添加文件',
            submit: '开始创建',
        },
        confirm: '确认',
        createFolder: '创建文件夹',
        goBack: '返回上一级',
        enterFolder: '进入文件夹',

        // 消息提示
        createSuccess: '创建成功',
        updateSuccess: '更新成功',
        deleteSuccess: '删除成功',
        moveSuccess: '移动成功',
        folderDeletedSuccess: '文件夹删除成功',
        projectDeletedSuccess: '项目删除成功',
        deleteItemFailed: '删除项目失败',
        createFailed: '创建失败，请重试',
        updateFailed: '更新失败，请重试',
        deleteFailed: '删除失败，请重试',
        moveFailed: '移动失败，请重试',
        fetchFailed: '获取数据失败，请重试',

        // 项目
        project: {
            name: '项目名称',
            namePlaceholder: '请输入项目名称',
            description: '描述',
            descriptionPlaceholder: '为项目添加描述信息',
            updateSuccess: '项目更新成功',
            updateFailed: '项目更新失败',
        },

        // 项目对话框
        projectDialog: {
            title: '编辑项目信息',
            createTitle: '新建项目',
            projectType: '项目类型',
            technicalField: '技术领域',
            technicalFieldOptions: {
                mechanical: '机械',
                electrical: '电学',
                chemical: '化学',
            },
            projectName: '项目名称',
            projectNamePlaceholder: '请输入项目名称（如：专利名称 - 202510087033.2）',
            optional: '选填',
            descriptionPlaceholder: '为项目添加详细描述信息',
            clientTags: '客户标签',
            clientTagsDescription: '为项目添加客户标签，方便管理和筛选',
            clientTagsPlaceholder: '输入或选择客户名称',
            save: '保存',
        },

        // 文件夹
        folder: {
            create: '创建文件夹',
            createDesc: '组织和管理您的项目',
            edit: '编辑文件夹',
            editDesc: '修改文件夹信息',
            name: '文件夹名称',
            namePlaceholder: '请输入文件夹名称',
            description: '描述',
            descriptionPlaceholder: '为文件夹添加描述信息',
            optional: '选填',
            color: '颜色',
            colorTip: '选择一个颜色标识文件夹',
            tags: '标签',
            tagsTip: '为文件夹添加客户端标签，方便筛选',
            loadFailed: '加载文件夹列表失败',
            inputPlaceholder: '输入或选择客户端',
        },

        // 筛选
        filter: {
            keyword: '搜索关键词',
            workType: '工作类型',
            client: '客户端',
            status: '状态',
            clearAll: '清除筛选',
        },

        // 工作类型筛选
        workType: {
            all: '全部',
            drafting: '撰写',
            prosecution: 'OAR',
            disclosure: '交底书',
            '00': '未指定',
            '01': '专利撰写',
            '10': '审查意见答复',
            '11': '组合项目',
            '20': '交底书',
        },

        // 客户端筛选
        // 视图
        view: {
            grid: '网格',
            list: '列表',
            board: '看板',
            gridView: '网格视图',
            listView: '列表视图',
        },

        // 排序
        sort: {
            name: '名称',
            created: '创建时间',
            updated: '更新时间',
            asc: '升序',
            desc: '降序',
        },
        sortByUpdated: '按更新时间',
        sortByCreated: '按创建时间',
        sortByNameAsc: '按名称升序',
        sortByNameDesc: '按名称降序',

        // 状态
        status: {
            draft: '撰写中',
            processing: '处理中',
            completed: '已完成',
            failed: '失败',
        },

        // 样式标签
        style: {
            standard: '标准',
            detailed: '详细',
            concise: '简洁',
        },

        // 对话框
        dialog: {
            moreActions: '更多操作',
            deleteConfirm: '确认删除',
            deleteMessage: '您确定要删除选中的项目吗？',
            deleteMultipleWarning: '您即将删除 <strong class="text-red-600 font-semibold">{count}</strong> 个项目。此操作无法撤销。',
            cannotUndo: '此操作无法撤销。',
            andMore: '还有 {count} 个...',
            deleting: '删除中...',
        },

        // 移动到文件夹对话框
        moveDialog: {
            current: '当前位置',
            moveHereToThisLocation: '移动到此位置',
            cannotMoveHere: '不能移动到此处',
            moveTo: '移动到...',
            moveHere: '移动到这里',
            movingProject: '正在移动 "{name}"',
            item: '项',
            items: '项',
            noSubfolders: '没有子文件夹',
            noSubfoldersDesc: '此文件夹不包含任何子文件夹',
            instructions: '操作说明',
            instructionsText: '点击选择，双击或使用箭头进入文件夹',
            selectedDestination: '已选目标位置',
            goBack: '返回上一级',
            enterFolder: '进入文件夹',
        },

        // 空状态
        empty: {
            noProjects: '还没有任何项目',
            noResults: '没有符合条件的项目',
            createFirst: '创建第一个项目',
            noItemsFound: '未找到任何项目',
        },

        // 计数格式化
        count: {
            project: '{count}个项目',
        },

        // API错误消息
        api: {
            fetchProjectsFailed: '获取项目列表失败',
            createProjectFailed: '创建项目失败',
            fetchRecentProjectsFailed: '获取最近项目失败',
            deleteProjectsFailed: '删除项目失败',
            updateProjectFailed: '更新项目失败',
            updateMetadataFailed: '更新项目元数据失败',
            moveProjectsFailed: '移动项目失败',
            fetchFoldersFailed: '获取文件夹列表失败',
            fetchAllFoldersFailed: '获取所有文件夹失败',
            createFolderFailed: '创建文件夹失败',
            updateFolderFailed: '更新文件夹失败',
            deleteFoldersFailed: '删除文件夹失败',
            moveFolderFailed: '移动文件夹失败',
            fetchStatsFailed: '获取统计数据失败',
            fetchFiltersFailed: '获取筛选数据失败',
        },

        // 文件夹操作消息
        folderCreateFailed: '创建文件夹失败',

        // 元数据操作
        metadata: {
            clickToCopyOaType: '点击复制 OA 类型',
            clickToCopyOaNumber: '点击复制 OA 编号',
            oaTypeCopied: 'OA 类型已复制',
            oaNumberCopied: 'OA 编号已复制',
            applicationNumberCopied: '申请号已复制',
            copyFailed: '复制失败',
        },

        // 系统文件夹
        systemFolder: {
            name: '默认文件夹',
            description: '系统创建',
            badge: '系统',
        },

        // 分享
        share: '分享',
        shareDialog: {
            title: '分享项目',
            shareType: '分享类型',
            public: '公开',
            company: '公司',
            personal: '个人',
            permission: '权限级别',
            readOnly: '只读',
            canEdit: '可编辑',
            expiresAt: '过期时间',
            expiresAtPlaceholder: '选择过期时间（不选则永不过期）',
            optional: '选填',
            selectUser: '选择用户',
            searchUserPlaceholder: '搜索用户名或邮箱...',
            shareLink: '分享链接',
            copy: '复制',
            close: '关闭',
            createShare: '创建分享',
            createSuccess: '分享创建成功',
            createSuccessAndCopied: '分享创建成功，链接已复制到剪贴板',
            autoCopyFailed: '链接自动复制失败，请手动复制',
            createFailed: '分享创建失败',
            linkCopied: '链接已复制到剪贴板',
            copyFailed: '复制失败',
            requireCompanyAccount: '需要企业账号',
            publicReadOnlyHint: '公开分享只能设置为只读权限',
            companyIdNotFound: '无法获取公司信息，请联系管理员',
            selectUserRequired: '请选择要分享的用户',
            expiry7Days: '7 天',
            expiry15Days: '15 天',
            expiry30Days: '30 天',
            expiryNever: '永久',
            noUsersFound: '未找到匹配的用户',
            sharedTo: '分享给',
            copyLink: '复制链接',
            publicHint: '任何拥有链接的人都可以查看此项目',
            companyHint: '仅您组织内的成员可以访问',
            personalHint: '仅被邀请的人可以访问',
        },
    },
};
